<template>
  <div class="department-tree">
    <!-- 搜索框 -->
    <div class="department-search-wrap">
      <el-input placeholder="输入部门名字查询" v-model="filterText" class="department-search">
        <i slot="suffix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>

    <!-- tree结构 -->
    <el-scrollbar class="department-wrapper" wrap-class="scrollbar-wrapper">
      <el-tree
        highlight-current
        :data="departmentTree"
        :props="defaultProps"
        node-key="id"
        :default-expanded-keys="defaultExpandedKeys"
        @node-click="selectCurrentDepartment"
        :expand-on-click-node="false"
        @node-contextmenu="showContextMenu"
        :indent="14"
        :filter-node-method="filterDepartment"
        ref="departmentTree"
      >
        <span
          class="custom-tree-node"
          slot-scope="{ node, data }"
          :class="data.parentId === '0' ? 'department-root-node-content' : ''"
        >
          <svg-icon :icon-class="data.parentId === '0' ?'box' : 'folder'" />

          <span>{{ node.label }}</span>
        </span>
      </el-tree>
    </el-scrollbar>

    <!-- 自定义右键菜单 -->
    <vue-context ref="menu" :close-on-scroll="true">
      <template slot-scope="child" v-if="child.data">
        <li>
          <a @click.prevent="setDepartmentOperation('add')">
            新增子部门
            <i class="el-icon-plus"></i>
          </a>
        </li>
        <li v-show="child.data.canModify">
          <a @click.prevent="setDepartmentOperation('modify')">
            编辑
            <i class="el-icon-edit"></i>
          </a>
        </li>
        <li v-show="child.data.canDelete">
          <a @click.prevent="setDepartmentOperation('delete')">
            删除
            <i class="el-icon-delete"></i>
          </a>
        </li>
      </template>
    </vue-context>

    <!-- 操作弹窗 -->
    <el-dialog
      :title="departmentOperationConfig.dialogTitle"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <p v-if="departmentOperationConfig.type === 'delete'">如果删除该部门，下面的所有人员会被并入到上一级。是否继续删除？</p>

      <el-form ref="departmentForm" :model="departmentForm" label-width="80px" v-else>
        <el-form-item label="部门名称">
          <el-input v-model="departmentForm.name"></el-input>
        </el-form-item>

        <el-form-item label="上级部门">
          <el-input v-model="departmentForm.parentName" disabled></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="saveDepartmentOperation"
        >{{departmentOperationConfig.saveButtonText}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import VueContext from "vue-context";
import { operationConfigs, isRootDepartment } from "../constant";

import "@/styles/context-menu.scss";

export default {
  components: {
    VueContext
  },

  data() {
    return {
      filterText: "",

      dialogVisible: false,

      departmentForm: {
        name: "",
        parentName: ""
      },

      defaultExpandedKeys: [],

      operationCurrentDepartment: {},

      departmentOperationConfig: {
        type: "",
        dialogTitle: "",
        saveButtonText: "",
        saveFunctionName: null
      },

      selectedCurrentDepartment: {},

      departmentTree: [],
      defaultProps: {
        children: "children",
        label: "departmentName",
        id: "id"
      }
    };
  },

  watch: {
    filterText(val) {
      this.$nextTick(_ => {
        this.$refs.departmentTree.filter(val);
      });
    },

    selectedCurrentDepartment: {
      handler(department) {
        this.$observer.$emit("changeDepartment", department);
      },
      deep: true
    }
  },

  created() {
    this.initDepartmentTree();
  },

  methods: {
    setSelectedCurrentDepartment(department) {
      // 设置当前高亮节点
      this.$nextTick(() => {
        this.$refs.departmentTree.setCurrentKey(department.id);
      });

      this.selectCurrentDepartment(department);
    },

    async initDepartmentTree() {
      this.departmentTree = await this.$api.getOrganizationAll();

      this.setSelectedCurrentDepartment(this.departmentTree[0]);

      this.defaultExpandedKeys = [this.departmentTree[0].id];

      this.$nextTick(_ => {
        this.addClassNameToRootNode();
      });
    },

    addClassNameToRootNode() {
      const node = document.getElementsByClassName(
        "department-root-node-content"
      )[0].parentNode;

      node.classList.add("deparment-root-node");
    },

    filterDepartment(value, data) {
      if (!value) return true;
      return data.departmentName.indexOf(value) !== -1;
    },

    selectCurrentDepartment(data) {
      let { id, departmentName, parentId } = data;

      this.selectedCurrentDepartment = {
        id,
        departmentName,
        parentId
      };
    },

    showContextMenu(event, data, node) {
      this.$refs.menu.open(event, {
        canModify: !isRootDepartment(data),
        canDelete: !isRootDepartment(data)
      });

      this.operationCurrentDepartment = data;
      this.operationCurrentDepartment.parentName = node.parent.label;
    },

    initDepartmentForm(type) {
      if (type === "modify")
        this.departmentForm = {
          name: this.operationCurrentDepartment.departmentName,
          parentName: this.operationCurrentDepartment.parentName
        };

      if (type === "add")
        this.departmentForm = {
          name: "",
          parentName: this.operationCurrentDepartment.departmentName
        };
    },

    setDepartmentOperation(type) {
      this.initDepartmentForm(type);
      this.dialogVisible = true;
      this.departmentOperationConfig = operationConfigs[type];
    },

    async saveDepartmentOperation() {
      const functionName = this.departmentOperationConfig.saveFunctionName;

      await this[functionName]();

      this.$observer.$emit("refsData");

      this.updateDepartmentTree(this.departmentOperationConfig.type);

      this.dialogVisible = false;
    },

    async updateDepartmentTree(type) {
      this.departmentTree = await this.$api.getOrganizationAll();

      // 设置默认展开的节点
      const defaultExpandedKeys = isRootDepartment(
        this.selectedCurrentDepartment
      )
        ? this.departmentTree[0].id
        : this.selectedCurrentDepartment.parentId;

      this.defaultExpandedKeys = [defaultExpandedKeys];

      const toggle =
        this.operationCurrentDepartment.id == this.selectedCurrentDepartment.id;

      if (type === "delete" && toggle)
        return this.setSelectedCurrentDepartment(this.departmentTree[0]);

      if (type === "modify" && toggle)
        this.selectedCurrentDepartment.departmentName = this.departmentForm.name;

      this.setSelectedCurrentDepartment(this.selectedCurrentDepartment);
    },

    async addDepartment() {
      await this.$api.addOrganization({
        departmentName: this.departmentForm.name,
        parentId: this.operationCurrentDepartment.id
      });
    },

    async modifyDepartment() {
      await this.$api.editOrganization({
        departmentName: this.departmentForm.name,
        id: this.operationCurrentDepartment.id,
        parentId: this.operationCurrentDepartment.parentId
      });
    },

    async deleteDepartment() {
      await this.$api.deleteOrganization({
        id: this.operationCurrentDepartment.id
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";

.department-tree {
  height: 100%;

  .department-search-wrap {
    padding: 20px 12px;

    .department-search {
      height: 40px;
    }
  }

  .department-wrapper {
    height: calc(100% - 80px);
  }

  ::v-deep .scrollbar-wrapper {
    overflow-x: hidden !important;
  }
}

::v-deep .el-tree {
  // 每列的高度
  .el-tree-node__content {
    height: 42px;
  }

  // 内容的样式
  .custom-tree-node {
    @include ellipsis;

    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: #1d2b3d;

    .svg-icon {
      margin: 0 10px;
      color: #1890ff;
      font-size: 18px;
    }
  }

  // 设置根节点元素样式
  .deparment-root-node {
    .el-tree-node__expand-icon {
      display: none;
    }

    .department-root-node-content {
      font-size: 16px;

      .svg-icon {
        color: #ff6f00;
        font-size: 20px;
      }
    }
  }

  .deparment-root-node ~ div {
    margin: 10px 0 0 -15px;
    padding-top: 10px;
    border-top: 1px solid rgba(29, 43, 61, 0.09);
  }
}

::v-deep .v-context {
  li a {
    display: flex;
    justify-content: space-between;
    align-items: center;

    i {
      font-size: 16px;
      line-height: 14px;
      font-weight: 400;
    }
  }
}
</style>